// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3peL8","header":"ClearentDisclaimer_header__1yiY6","inner":"ClearentDisclaimer_inner__vWba1"};